module.exports = __webpack_public_path__ + "img/neutral.9b8f37e9.gif";